<div class="primary-version">
  <div class="version" [routerLink]="[urlPrefix, asset.version]">
    <span class="label label-primary-full">{{ asset.version_data.version_name || 'v1' | uppercase }}</span>
    <img [src]="asset | assetUrl: asset.version_data.watermark_uuid : 64 | async" alt="" />
    <div class="version-info">
      <div class="primary">{{ 'primary-tag' | translate }}</div>
      <b
        >{{ names[asset.version_data.id]?.name }}<span>.{{ names[asset.version_data.id]?.ext }}</span></b
      >
      <span class="date">{{
        (asset.version_data.created_at * 1000 | date: 'MMM d, yyyy') +
          ' at ' +
          (asset.version_data.created_at * 1000 | date: 'HH:mm')
      }}</span>
    </div>
    <app-svg src="/assets/icons/eye-open.svg"></app-svg>
  </div>
</div>
<div class="versions" [class.small]="small">
  @if (versions) {
    @for (version of versions; track version.id) {
      <a class="version" [routerLink]="[urlPrefix, version.id]" queryParamsHandling="preserve">
        <span class="label label-orange-full">{{ version.version_name || 'v1' | uppercase }}</span>
        <img
          [src]="
            version
              | assetVersionUrl
                : version.uuid
                : version['status']
                : version.watermark_uuid
                : 64
                : undefined
                : asset.watermark_enabled
              | async
          "
          alt=""
        />
        <div class="version-info">
          <b
            >{{ names[version.id]?.name }}<span>.{{ names[version.id]?.ext }}</span></b
          >
          <span class="date">{{
            (version.created_at * 1000 | date: 'MMM d, yyyy') + ' at ' + (version.created_at * 1000 | date: 'HH:mm')
          }}</span>
        </div>
        <app-svg src="/assets/icons/arrow-right.svg"></app-svg>
      </a>
    }
  } @else {
    <app-loading-indicator [size]="'small'"></app-loading-indicator>
  }
</div>
